export default __webpack_public_path__ + "static/media/Subtraction_05.e69b7a17.png";